// extracted by mini-css-extract-plugin
module.exports = {"containerMenu":"Menu_containerMenu__3WgnP","item":"Menu_item__whgYv"};